module.exports = __webpack_public_path__ + "assets/img/comp_3.66101077.png";